var map = {
	"./coin/anim/in/coin_in_000.png": 2270,
	"./coin/anim/in/coin_in_001.png": 2271,
	"./coin/anim/in/coin_in_002.png": 2272,
	"./coin/anim/in/coin_in_003.png": 2273,
	"./coin/anim/in/coin_in_004.png": 2274,
	"./coin/anim/in/coin_in_005.png": 2275,
	"./coin/anim/in/coin_in_006.png": 2276,
	"./coin/anim/in/coin_in_007.png": 2277,
	"./coin/anim/in/coin_in_008.png": 2278,
	"./coin/anim/in/coin_in_009.png": 2279,
	"./coin/anim/in/coin_in_010.png": 2280,
	"./coin/anim/in/coin_in_011.png": 2281,
	"./coin/anim/in/coin_in_012.png": 2282,
	"./coin/anim/in/coin_in_013.png": 2283,
	"./coin/anim/in/coin_in_014.png": 2284,
	"./coin/anim/in/coin_in_015.png": 2285,
	"./coin/anim/in/coin_in_016.png": 2286,
	"./coin/anim/in/coin_in_017.png": 2287,
	"./coin/anim/in/coin_in_018.png": 2288,
	"./coin/anim/in/coin_in_019.png": 2289,
	"./coin/anim/in/coin_in_020.png": 2290,
	"./coin/anim/in/coin_in_021.png": 2291,
	"./coin/anim/in/coin_in_022.png": 2292,
	"./coin/anim/in/coin_in_023.png": 2293,
	"./coin/anim/in/coin_in_024.png": 2294,
	"./coin/anim/in/coin_in_025.png": 2295,
	"./coin/anim/out_1/out_1_000.png": 2296,
	"./coin/anim/out_1/out_1_001.png": 2297,
	"./coin/anim/out_1/out_1_002.png": 2298,
	"./coin/anim/out_1/out_1_003.png": 2299,
	"./coin/anim/out_1/out_1_004.png": 2300,
	"./coin/anim/out_1/out_1_005.png": 2301,
	"./coin/anim/out_1/out_1_006.png": 2302,
	"./coin/anim/out_1/out_1_007.png": 2303,
	"./coin/anim/out_1/out_1_008.png": 2304,
	"./coin/anim/out_1/out_1_009.png": 2305,
	"./coin/anim/out_2/out_2_000.png": 2306,
	"./coin/anim/out_2/out_2_001.png": 2307,
	"./coin/anim/out_2/out_2_002.png": 2308,
	"./coin/anim/out_2/out_2_003.png": 2309,
	"./coin/anim/out_2/out_2_004.png": 2310,
	"./coin/anim/out_2/out_2_005.png": 2311,
	"./coin/anim/out_2/out_2_006.png": 2312,
	"./coin/anim/out_2/out_2_007.png": 2313,
	"./coin/anim/out_2/out_2_008.png": 2314,
	"./coin/anim/out_2/out_2_009.png": 2315,
	"./coin/anim/shine_1/shine_1_000.png": 2316,
	"./coin/anim/shine_1/shine_1_001.png": 2317,
	"./coin/anim/shine_1/shine_1_002.png": 2318,
	"./coin/anim/shine_1/shine_1_003.png": 2319,
	"./coin/anim/shine_1/shine_1_004.png": 2320,
	"./coin/anim/shine_1/shine_1_005.png": 2321,
	"./coin/anim/shine_1/shine_1_006.png": 2322,
	"./coin/anim/shine_1/shine_1_007.png": 2323,
	"./coin/anim/shine_1/shine_1_008.png": 2324,
	"./coin/anim/shine_1/shine_1_009.png": 2325,
	"./coin/anim/shine_1/shine_1_010.png": 2326,
	"./coin/anim/shine_1/shine_1_011.png": 2327,
	"./coin/anim/shine_1/shine_1_012.png": 2328,
	"./coin/anim/shine_1/shine_1_013.png": 2329,
	"./coin/anim/shine_1/shine_1_014.png": 2330,
	"./coin/anim/shine_1/shine_1_015.png": 2331,
	"./coin/anim/shine_1/shine_1_016.png": 2332,
	"./coin/anim/shine_1/shine_1_017.png": 2333,
	"./coin/anim/shine_1/shine_1_018.png": 2334,
	"./coin/anim/shine_1/shine_1_019.png": 2335,
	"./coin/anim/shine_1/shine_1_020.png": 2336,
	"./coin/anim/shine_1/shine_1_021.png": 2337,
	"./coin/anim/shine_1/shine_1_022.png": 2338,
	"./coin/anim/shine_1/shine_1_023.png": 2339,
	"./coin/anim/shine_1/shine_1_024.png": 2340,
	"./coin/anim/shine_1/shine_1_025.png": 2341,
	"./coin/anim/shine_1/shine_1_026.png": 2342,
	"./coin/anim/shine_1/shine_1_027.png": 2343,
	"./coin/anim/shine_1/shine_1_028.png": 2344,
	"./coin/anim/shine_1/shine_1_029.png": 2345,
	"./coin/anim/shine_1/shine_1_030.png": 2346,
	"./coin/anim/shine_2/shine_2_000.png": 2347,
	"./coin/anim/shine_2/shine_2_001.png": 2348,
	"./coin/anim/shine_2/shine_2_002.png": 2349,
	"./coin/anim/shine_2/shine_2_003.png": 2350,
	"./coin/anim/shine_2/shine_2_004.png": 2351,
	"./coin/anim/shine_2/shine_2_005.png": 2352,
	"./coin/anim/shine_2/shine_2_006.png": 2353,
	"./coin/anim/shine_2/shine_2_007.png": 2354,
	"./coin/anim/shine_2/shine_2_008.png": 2355,
	"./coin/anim/shine_2/shine_2_009.png": 2356,
	"./coin/anim/shine_2/shine_2_010.png": 2357,
	"./coin/anim/shine_2/shine_2_011.png": 2358,
	"./coin/anim/shine_2/shine_2_012.png": 2359,
	"./coin/anim/shine_2/shine_2_013.png": 2360,
	"./coin/anim/shine_2/shine_2_014.png": 2361,
	"./coin/anim/shine_2/shine_2_015.png": 2362,
	"./coin/anim/shine_2/shine_2_016.png": 2363,
	"./coin/anim/shine_2/shine_2_017.png": 2364,
	"./coin/anim/shine_2/shine_2_018.png": 2365,
	"./coin/anim/shine_2/shine_2_019.png": 2366,
	"./coin/anim/shine_2/shine_2_020.png": 2367,
	"./coin/anim/shine_2/shine_2_021.png": 2368,
	"./coin/anim/shine_2/shine_2_022.png": 2369,
	"./coin/anim/shine_2/shine_2_023.png": 2370,
	"./coin/anim/shine_2/shine_2_024.png": 2371,
	"./coin/anim/shine_2/shine_2_025.png": 2372,
	"./coin/anim/shine_2/shine_2_026.png": 2373,
	"./coin/anim/shine_2/shine_2_027.png": 2374,
	"./coin/anim/shine_2/shine_2_028.png": 2375,
	"./coin/anim/shine_2/shine_2_029.png": 2376,
	"./coin/anim/shine_2/shine_2_030.png": 2377,
	"./coin/coin_dice_1.png": 2378,
	"./coin/coin_dice_2.png": 2379,
	"./coin/coin_start_1.png": 2380,
	"./coin/coin_start_2.png": 2381,
	"./coin_start_1.png": 2382,
	"./coin_start_2.png": 2383,
	"./header-babaijebu.png": 366,
	"./one.svg": 2384,
	"./two.svg": 2385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2269;


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img \.(gif|png|jpe?g|svg)$/
// module id = 2269
// module chunks = 5